import { FullCalendarModule } from '@fullcalendar/angular'; // must go before plugins
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimesheetEditDialogComponent } from './view/timesheet-edit-dialog/timesheet-edit-dialog.component';
import { CalendarModule } from 'primeng/calendar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TimesheetsComponent } from './view/timesheets/timesheets.component';
import { TimesheetsPageComponent } from './view/timesheets/timesheets-page/timesheets-page.component';
import { ApprovalsPageComponent } from './view/timesheets/approvals-page/approvals-page.component';
import { DesktopProjectModule } from '../project/desktop-project.module';
import {
  TimesheetsPeriodDialogComponent
} from './view/timesheets/approvals-page/timesheets-period-dialog/timesheets-period-dialog.component';
import { MiscModule } from 'projects/core/src/public-api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import {
  TimesheetsReportDialogComponent
} from './view/timesheets/approvals-page/timesheets-report-dialog/timesheets-report-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {
  AdditionalReportInfoComponent
} from './view/timesheets/approvals-page/timesheets-report-dialog/additional-report-info/additional-report-info.component';
import {
  MapMarkerDialogComponent
} from './view/timesheets/approvals-page/timesheets-report-dialog/map-marker-dialog/map-marker-dialog.component';
import { ProjectMiscModule } from 'projects/app-misc/src/app/modules/project-misc/project-misc.module';
import { VacationCalendarComponent } from './view/vacation-calendar/vacation-calendar.component';
import { RouterModule } from '@angular/router';
import { VacationDayDialogComponent } from './view/vacation-calendar/vacation-day-dialog/vacation-day-dialog.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TooltipModule } from 'primeng/tooltip';
import {
  AdditionalReportHeaderComponent
} from './view/timesheets/approvals-page/timesheets-report-dialog/additional-report-header/additional-report-header.component';
import {
  VacationPdfGenerateDialogComponent
} from './view/vacation-calendar/vacation-pdf-generate-dialog/vacation-pdf-generate-dialog.component';
import { HttpClientModule } from '@angular/common/http';
import { MultiSelect, MultiSelectModule } from 'primeng/multiselect';
import { VacationRejectDialogComponent } from './view/vacation-calendar/vacation-reject-dialog/vacation-reject-dialog.component';
import {
  CsvImportExportDialogComponent
} from './view/timesheets/approvals-page/csv-import-export-dialog/csv-import-export-dialog.component';


@NgModule({
  declarations: [
    TimesheetsPageComponent,
    TimesheetEditDialogComponent,
    TimesheetsComponent,
    ApprovalsPageComponent,
    TimesheetsPeriodDialogComponent,
    TimesheetsReportDialogComponent,
    AdditionalReportInfoComponent,
    MapMarkerDialogComponent,
    VacationCalendarComponent,
    VacationDayDialogComponent,
    AdditionalReportHeaderComponent,
    VacationPdfGenerateDialogComponent,
    VacationRejectDialogComponent,
    CsvImportExportDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    FullCalendarModule,
    TooltipModule,
    MatDialogModule,
    MatRippleModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    SelectButtonModule,
    CalendarModule,
    CheckboxModule,
    MiscModule,
    DropdownModule,
    ConfirmDialogModule,
    DesktopProjectModule,
    ProjectMiscModule,
    RouterModule,
    OverlayPanelModule,
    MultiSelectModule
  ],
  entryComponents: [
    TimesheetEditDialogComponent,
    TimesheetsPeriodDialogComponent,
    TimesheetsReportDialogComponent,
    MapMarkerDialogComponent,
    VacationDayDialogComponent,
    VacationPdfGenerateDialogComponent,
    CsvImportExportDialogComponent
  ]
})
export class TimesheetsModule {
}
